import getStore from '../store';
import { processCalendarViewType } from '../utils/processCalendarViewType';
import { addDatapointConfig } from 'owa-analytics-actions';
import { CalendarViewTypeEnum } from 'owa-calendar-view-type';
import { action } from 'satcheljs';
import { default as SelectedViewTypeSource } from '../schema/SelectedViewTypeSource';

export const updateSelectedViewType = action(
    'updateSelectedViewType',
    (viewType: CalendarViewTypeEnum, source: SelectedViewTypeSource) =>
        addDatapointConfig(
            {
                name: 'SwitchCalendarView',
                customData: {
                    CurrentViewType_1: getStore().selectedViewType,
                    NewViewType_2: processCalendarViewType(viewType),
                    Source_3: source,
                },
                options: {
                    isCore: true,
                },
            },
            {
                viewType: processCalendarViewType(viewType),
            }
        )
);
